import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'
import { useDocumentFiltersContext } from '@/components/document-filters/DocumentFiltersProvider'

export default function FlagsFilter() {
  const { documentFilters, handleOnDocumentFilterChange } =
    useDocumentFiltersContext()

  const onChangeHandler = (flagCode: string, checked: boolean) => {
    handleOnDocumentFilterChange((prev) => {
      if (!prev)
        return {
          noFlags: false,
          flagCodes: [flagCode],
          orgIds: [],
          teamIds: [],
        }

      const newFilters = { ...prev }
      if (checked) {
        newFilters.flagCodes = [...newFilters.flagCodes, flagCode]
      } else {
        newFilters.flagCodes = newFilters.flagCodes.filter(
          (id) => id !== flagCode,
        )
      }
      return { ...newFilters, noFlags: false } // If we're choosing a flag code, always set noFlags to false
    })
  }

  const onChangeNoFlags = (checked: boolean) => {
    handleOnDocumentFilterChange((prev) => {
      if (!prev)
        return {
          noFlags: checked,
          flagCodes: [],
          orgIds: [],
          teamIds: [],
        }

      return {
        ...prev,
        noFlags: checked,
        flagCodes: [], // If we're choosing no flags, always clear the flag codes
      }
    })
  }

  return (
    documentFilters && (
      <Stack direction="column" spacing={1}>
        <Typography>Flags</Typography>
        <Stack spacing={0.5}>
          <FormControlLabel
            label="No Flags"
            control={
              <Checkbox
                sx={{ padding: 0 }}
                checked={documentFilters.noFlags}
                onChange={(_e, checked) => onChangeNoFlags(checked)}
              />
            }
            slotProps={{ typography: { variant: 'body2' } }}
            sx={{ mx: 0, columnGap: 0.5 }}
          />
          <FormControlLabel
            label="Has Errors"
            control={
              <Checkbox
                sx={{ padding: 0 }}
                color="error"
                checked={documentFilters.flagCodes.includes('error')}
                onChange={(_e, checked) => onChangeHandler('error', checked)}
              />
            }
            slotProps={{ typography: { variant: 'body2' } }}
            sx={{ mx: 0, columnGap: 0.5 }}
          />
          <FormControlLabel
            label="Has Warnings"
            control={
              <Checkbox
                sx={{ padding: 0 }}
                color="warning"
                checked={documentFilters.flagCodes.includes('warning')}
                onChange={(_e, checked) => onChangeHandler('warning', checked)}
              />
            }
            slotProps={{ typography: { variant: 'body2' } }}
            sx={{ mx: 0, columnGap: 0.5 }}
          />
          <FormControlLabel
            label="Has Infos"
            control={
              <Checkbox
                sx={{ padding: 0 }}
                color="neutral"
                checked={documentFilters.flagCodes.includes('info')}
                onChange={(_e, checked) => onChangeHandler('info', checked)}
              />
            }
            slotProps={{ typography: { variant: 'body2' } }}
            sx={{ mx: 0, columnGap: 0.5 }}
          />
        </Stack>
      </Stack>
    )
  )
}
